import { defineStore } from "pinia";

import { COUNTRIES_FILTER_QUERY } from "@/api/enforcement/countries.ts";
import { apollo } from "@/utils/apollo.ts";

export const useCountriesStore = defineStore("countries", {
  state: () => ({
    all: [],
  }),

  actions: {
    async fetchAll(params = {}) {
      try {
        const { data } = await apollo.query({
          query: COUNTRIES_FILTER_QUERY,
          variables: {
            ...params,
            limit: 100,
            isActive: true,
          },
        });
        this.all = data.getCountries.data;
      }
      catch (error) {
        console.error(error);
      }
    },
  },
});
